var map = {
	"./pr-1.png": "7f35",
	"./pr-10.png": "4378",
	"./pr-2.png": "a9d7",
	"./pr-3.png": "e42e",
	"./pr-4.png": "322a",
	"./pr-5.png": "b525",
	"./pr-6.png": "70cf",
	"./pr-7.png": "aea1",
	"./pr-8.png": "756a",
	"./pr-9.png": "c076"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9a1";